export const featuredSlider = () => {
  const settings = {
    arrows: true,
    dots: false,
    centerMode: false,
    centerPadding: "30px",
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    variableHeight: false,
    infinite: false,
    appendArrows: $(".css--featured-services__arrows"),
    prevArrow: $(".css--featured-services .slick-arrow.slick-prev"),
    nextArrow: $(".css--featured-services .slick-arrow.slick-next"),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if ($(".css--featured-services__cards").length) {
    $(".css--featured-services__cards").slick(settings);
    // $(".css--featured-services__cards").on(
    //   "afterChange",
    //   function (event, slick, currentSlide) {
    //     if (currentSlide > slick.slideCount / settings.slidesToScroll) {
    //       $(".slick-next").addClass("slick-disabled");
    //     } else {
    //       $(".slick-next").removeClass("slick-disabled");
    //     }
    //   }
    // );
  }
};

export const insightsSlider = () => {
  const settings = {
    arrows: false,
    dots: false,
    slidesToShow: 2,
    centerPadding: 0,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerPadding: "40px",
        },
      },
    ],
  };
  if ($(".css--insights__cards").length)
    $(".css--insights__cards").slick(settings);
};
export const cardSlider = () => {
  const settings = {
    dots: false,
    slidesToShow: 4,
    centerPadding: 0,
    // prevArrow: '<img src="/assets/slider-lt.png" alt="" />',
    // nextArrow: '<img src="/assets/slider-rt.png" alt="" />',
    prevArrow: $(".css--card-slider .slick-arrow.slick-prev"),
    nextArrow: $(".css--card-slider .slick-arrow.slick-next"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerPadding: "40px",
        },
      },
    ],
  };
  if ($(".css--card-slider__slides").length)
    $(".css--card-slider__slides").slick(settings);
};
